import { useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import Modal from '../ui/Modal';
import Select from '../ui/Select';
import Textarea from '../ui/Textarea';
import Button from '../ui/Button';
import { IconXCircle, IconClose } from '../ui/icons';
import { listRejectionReasons } from '../../api/masters';

export default function RejectDialog({ open, onClose, onConfirm, loading, actionLabel, closesRecruitment }) {
  const [reasonId, setReasonId] = useState('');
  const [remark, setRemark] = useState('');

  const reasonsQuery = useQuery({ queryKey: ['rejection-reasons'], queryFn: () => listRejectionReasons(), enabled: open });
  const reasons = reasonsQuery.data || [];
  const selected = reasons.find((r) => String(r.id) === reasonId);
  // With no predefined reasons configured yet, fall back to a required free-text remark.
  const noReasons = !reasonsQuery.isLoading && reasons.length === 0;

  const handleClose = () => {
    setReasonId('');
    setRemark('');
    onClose();
  };

  const handleConfirm = () => onConfirm([selected?.name, remark.trim()].filter(Boolean).join(': '));

  const canSubmit = noReasons ? !!remark.trim() : !!selected;

  return (
    <Modal
      open={open}
      onClose={handleClose}
      title={actionLabel}
      footer={
        <>
          <Button variant="secondary" onClick={handleClose} disabled={loading}>
            <IconClose className="h-4 w-4" />
            Cancel
          </Button>
          <Button variant="danger" onClick={handleConfirm} loading={loading} disabled={!canSubmit}>
            <IconXCircle className="h-4 w-4" />
            {actionLabel}
          </Button>
        </>
      }
    >
      {closesRecruitment && (
        <p className="mb-3 rounded-md bg-red-50 px-3 py-2 text-sm text-red-700">
          This will close the candidate's recruitment and mark them Rejected.
        </p>
      )}
      {!noReasons && (
        <Select label="Reason" required value={reasonId} onChange={(e) => setReasonId(e.target.value)} className="mb-4">
          <option value="">Select a reason…</option>
          {reasons.map((r) => (
            <option key={r.id} value={r.id}>
              {r.name}
            </option>
          ))}
        </Select>
      )}
      <Textarea
        label={noReasons ? 'Reason' : 'Remark (optional)'}
        required={noReasons}
        value={remark}
        onChange={(e) => setRemark(e.target.value)}
      />
    </Modal>
  );
}
